// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import useTranslation from "next-translate/useTranslation";

import { Form } from "@/components/core";
import { SelectOptions } from "./select-options";

const data = [
  {
    value: "00000014-4f7b-49ca-bd5d-38534d354185",
    isoCode: "TL",
    label: "Türk Lirası",
  },
  {
    value: "00000014-127c-41ac-9daf-e0853f8e50e2",
    isoCode: "EUR",
    label: "Euro",
  },
  {
    value: "00000014-cc12-4c0b-b400-453c1224a189",
    isoCode: "USD",
    label: "Amerikan Doları",
  },
  {
    value: "00000014-5908-4ab5-8e11-21206c2a8e86",
    isoCode: "GBP",
    label: "İngiliz sterlini",
  },
];

export function SimpleCurrencySelect({ name, value, onChange }: any) {
  const [currencies, setCurrencies] = useState([]);

  const { t } = useTranslation("common");

  useEffect(() => {
    setCurrencies(data);
  }, []);

  const renderItem = (currency: any) => <SelectOptions currency={currency} key={currency.value} />;

  return (
    <Form.Select
      label={t("selectCurrency")}
      name={name}
      options={currencies}
      value={value}
      onChange={onChange}
      renderItem={renderItem}
    />
  );
}

SimpleCurrencySelect.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export function CurrencySelect({ name, value, onChange }: any) {
  const { t } = useTranslation("common");

  const renderOption = (params: any, currency: any) => (
    <SelectOptions currency={currency} {...params} key={currency.value} />
  );
  const renderInput = (params: any) => <TextField {...params} label={t("selectCurrency")} />;

  return (
    <Form.AutoComplete
      name={name}
      options={data}
      value={value}
      onChange={onChange}
      renderOption={renderOption}
      renderInput={renderInput}
    />
  );
}

CurrencySelect.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
};
